import { call, put, takeLatest } from "redux-saga/effects";
import {
  SG_GET_SURVEY_TEMPLATE_QUESTIONS,
  GET_SURVEY_TEMPLATE_QUESTIONS,
  SG_FETCH_SURVEY_TEMPLATE_QUESTION,
  FETCH_SURVEY_TEMPLATE_QUESTION,
  SG_ADD_SURVEY_TEMPLATE_QUESTION,
  ADD_SURVEY_TEMPLATE_QUESTION,
  SG_UPDATE_SURVEY_TEMPLATE_QUESTION,
  UPDATE_SURVEY_TEMPLATE_QUESTION,
  SG_DELETE_SURVEY_TEMPLATE_QUESTION,
  DELETE_SURVEY_TEMPLATE_QUESTION,
  SURVEY_TEMPLATE_QUESTIONS_PENDING,
  ALL_ERRORS,
} from "constants/actions";
import * as api from "constants/api";

function* getSurveyTemplateQuestions(action) {
  try {
    yield put({ type: SURVEY_TEMPLATE_QUESTIONS_PENDING });
    const response = yield call(api.GET_SURVEY_TEMPLATE_QUESTIONS, action.payload);
    yield put({ type: GET_SURVEY_TEMPLATE_QUESTIONS, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* fetchSurveyTemplateQuestion(action) {
  try {
    yield put({ type: SURVEY_TEMPLATE_QUESTIONS_PENDING });
    const response = yield call(api.FETCH_SURVEY_TEMPLATE_QUESTION, action.payload);
    yield put({ type: FETCH_SURVEY_TEMPLATE_QUESTION, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* addSurveyTemplateQuestion(action) {
  try {
    yield put({ type: SURVEY_TEMPLATE_QUESTIONS_PENDING });
    const response = yield call(api.ADD_SURVEY_TEMPLATE_QUESTION, action.payload);
    yield put({ type: ADD_SURVEY_TEMPLATE_QUESTION, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* updateSurveyTemplateQuestion(action) {
  try {
    yield put({ type: SURVEY_TEMPLATE_QUESTIONS_PENDING });
    const response = yield call(api.UPDATE_SURVEY_TEMPLATE_QUESTION, action.payload);
    yield put({ type: UPDATE_SURVEY_TEMPLATE_QUESTION, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* deleteSurveyTemplateQuestion(action) {
  try {
    yield put({ type: SURVEY_TEMPLATE_QUESTIONS_PENDING });
    yield call(api.DELETE_SURVEY_TEMPLATE_QUESTION, action.payload);
    yield put({ type: DELETE_SURVEY_TEMPLATE_QUESTION, payload: action.payload });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export default function* surveyTemplateQuestionsSaga() {
  yield takeLatest(SG_GET_SURVEY_TEMPLATE_QUESTIONS, getSurveyTemplateQuestions);
  yield takeLatest(SG_FETCH_SURVEY_TEMPLATE_QUESTION, fetchSurveyTemplateQuestion);
  yield takeLatest(SG_ADD_SURVEY_TEMPLATE_QUESTION, addSurveyTemplateQuestion);
  yield takeLatest(SG_UPDATE_SURVEY_TEMPLATE_QUESTION, updateSurveyTemplateQuestion);
  yield takeLatest(SG_DELETE_SURVEY_TEMPLATE_QUESTION, deleteSurveyTemplateQuestion);
}